import type { DefaultMessagesKeys } from '@src/i18n/useTranslate';
import type { TariffGroupAttributeType } from '@src/domains/products/features/product-booking/types/attribute';

export const ATTRIBUTE_TYPE_I18N_KEYS: Record<TariffGroupAttributeType, DefaultMessagesKeys> = {
  pickup_zone: 'product_booking_attribute_pickup_zone_label' as DefaultMessagesKeys,
};

export const humanizeAttributeType = (type: TariffGroupAttributeType): string => {
  const words = type.trim().replace(/[_-]+/g, ' ').trim();

  if (!words) {
    return '';
  }

  return words.charAt(0).toUpperCase() + words.slice(1);
};

export const getAttributeTypeI18nKey = (type: TariffGroupAttributeType): DefaultMessagesKeys | undefined =>
  ATTRIBUTE_TYPE_I18N_KEYS[type];

export const getAttributeTypeLabel = (
  type: TariffGroupAttributeType,
  translate: (key: DefaultMessagesKeys | undefined) => string,
): string => {
  const key = getAttributeTypeI18nKey(type);
  const translated = key ? translate(key) : '';

  return translated || humanizeAttributeType(type);
};
